import { DataTableSortableHeader } from '@softwaredev_cegeka/stix-data-table'
import debounce from 'lodash.debounce'

export function serializeParamsWithoutBrackets(params) {
    let serializedParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
        if (value instanceof Array) {
            value.forEach(singleVal => {
                serializedParams.append(key, singleVal)
            })
        } else {
            serializedParams.append(key, value)
        }
    })
    return serializedParams.toString()
}

export function extractParams(page, history) {
    let location
    let urlSearchParams

    if (history) {
        location = history.location
        urlSearchParams = new URLSearchParams(location.search)
        // If no page was passed, get page number from search params. This should only happen on page load.
        if (!page && urlSearchParams.has('page')) {
            page = parseInt(urlSearchParams.get('page'), 10)
        }
    }

    return {
        currentPage: page,
        urlSearchParams: urlSearchParams,
        location: location,
    }
}

export function updateHistory(history, location, page, urlSearchParams) {
    // Update the history with the page number last fetched.
    if (history && page) {
        urlSearchParams.set('page', page)
        history.replace({
            ...location,
            search: `?${urlSearchParams.toString()}`,
        })
    }
}

export function sortObjectToString(obj) {
    const { ASC } = DataTableSortableHeader.SORT
    const { direction, column } = obj

    if (!direction || !column) {
        return null
    }

    return direction === ASC ? `+${column}` : `-${column}`
}

export const debouncedLoadData = debounce((params, setParams) => {
    setParams(params)
}, 400)

export function sortData(column, direction, params, setSort, setParams) {
    const newSortObj = { column, direction }
    const sortString = sortObjectToString(newSortObj)

    if (sortString) {
        params.sort = sortString
    }

    setSort(newSortObj)
    setParams(params)
}

export function formatDate(
    date,
    options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    }
) {
    if (!date) {
        return '-'
    }
    if (typeof date === 'string') {
        // Year month ex. 202009
        if (date.length === 6) {
            date = `${date.slice(0, 4)}-${date.slice(4, 6)}-01`
        }
        date = new Date(Date.parse(date))
    } else if (typeof date === 'number') {
        date = new Date(date * 1000)
    }

    return new Intl.DateTimeFormat('nl-BE', options).format(date)
}
